<template>
  <div class="rodent-map ls">
    <vue-amap
      ref="amap"
      :d3-features="['bg', 'road', 'point']"
      :bounds="bounds"
      :zoom="zoom"
      @complete="setMarkers"
    ></vue-amap>
  </div>
</template>

<script>
import Vue from 'vue'
import VueAmap from '@/components/Amap/index.vue'
import jData from '@/assets/sites.json'

export default {
  components: { VueAmap },
  props: { devKey: String, devs: Array },
  data() {
    return {
      width: 100,
      bounds: [],
      center: [],
      zoom: 10
    }
  },
  computed: {
    markers() {
      return this.devs.map(d => {
        const content = this.getContent(d.id)
        const info = this.getInfo(d)
        return { lat: +d.lat, lng: +d.lng, content, info }
      })
    }
  },
  created() {
    this.init()
  },
  mounted() {
    this.layout()
  },
  methods: {
    init() {
      try {
        const site = jData.find(o => +o.companyId === +this.companyId)
        if (site && site.geo) {
          const geoJson = require(`@/assets/geo/${site.geo}.json`)
          this.bounds = geoJson.features[0].geometry.coordinates[0]
          this.center = geoJson.features[0].properties.center
        }
      } catch (e) {
        console.log(e)
      }
    },
    layout() {
      this.width = this.$el.clientWidth
    },
    getContent(key) {
      const isActived = key === this.devKey
      const el = new Vue({
        render(h) {
          const content = h('svg-icon', { props: { iconClass: 'mouse' } })
          return h(
            'div',
            {
              class: `amap-marker amap-marker__small ${
                isActived ? 'actived' : ''
              }`,
              style: `color: #E6A23C;`,
              ref: 'node'
            },
            [content]
          )
        }
      }).$mount()
      return el.$refs.node
    },
    getInfo(device) {
      let el = document.createElement('div')
      el.className = 'amap-marker__title'
      el.innerHTML = device.name
      el.onclick = () => {
        this.$emit('change', device)
      }
      return el
    },
    setMarkers() {
      if (this.markers.length && this.$refs.amap) {
        this.$refs.amap.setMarkers(this.markers)
        if (this.center && this.center[0]) {
          let [lon, lat] = this.center
          this.$refs.amap.setCenter([lon, lat])
        }
      }
    },
    setFocus(id) {
      const index = this.devs.findIndex(t => t.id === id)
      if (index >= 0) {
        const device = this.devs[index]
        this.$refs.amap.setCenter([+device.lng, +device.lat])
        this.$refs.amap.setFocus(index)
      }
    }
  },
  watch: {
    devKey(key) {
      this.setFocus(key)
    },
    devs() {
      this.setMarkers()
    }
  }
}
</script>

<style lang="scss">
$marker-small: 32px;
$marker-size: 14px; // 图标尺寸
$marker-text-size: 14px;
$marker-text-lineheight: 32px;
$marker-focus-size: 48px;

.rodent-map.ls {
  // padding: 12px;
  height: 100%;
  box-sizing: border-box;
  // margin-bottom: 40px;
  .amap-marker__small {
    display: flex;
    width: $marker-small;
    height: $marker-small;
    border-radius: 50%;
    background: rgba(27, 43, 55, 0.8);
    align-items: center;
    justify-content: center;
  }
  .amap-marker__small.actived {
    transform: scale(1.2);
    border: 1px solid #209e91;
    .svg-icon {
      color: #fff;
    }
  }
  .svg-icon {
    font-size: $marker-size;
    width: $marker-size;
  }
  .amap-marker__title {
    padding-left: 1rem;
    padding-right: 1rem;
    color: #f2f6fc;
    height: $marker-text-lineheight;
    line-height: $marker-text-lineheight;
    font-size: $marker-text-size;
    background-color: #1b2b37;
    border-radius: 3px;
    overflow: hidden;
    cursor: pointer;
  }
}
</style>
